
import { Options, Vue } from 'vue-class-component';
import axios from 'axios';

declare const window: any;

const RECAPTCHA_SITE_KEY = '6LfO-DgtAAAAAHdcmesZWxAqabav2m-FRQNCBtGl';

@Options({})
export default class BRollRequestView extends Vue {
  form = {
    email: '',
    socials: [{ platform: '', url: '' }],
    games: [''],
  };

  errors: Record<string, string> = {};
  submitError = '';
  loading = false;
  submitted = false;

  mounted() {
    if (!document.getElementById('recaptcha-script')) {
      const script = document.createElement('script');
      script.id = 'recaptcha-script';
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  addSocial() {
    this.form.socials.push({ platform: '', url: '' });
  }

  removeSocial(index: number) {
    this.form.socials.splice(index, 1);
  }

  addGame() {
    this.form.games.push('');
  }

  removeGame(index: number) {
    this.form.games.splice(index, 1);
  }

  validate(): boolean {
    this.errors = {};
    if (!this.form.email || !this.form.email.includes('@')) {
      this.errors.email = 'A valid email address is required.';
    }
    if (!this.form.socials.some(s => s.url.trim())) {
      this.errors.socials = 'At least one social link with a URL is required.';
    }
    if (!this.form.games.some(g => g.trim())) {
      this.errors.games = 'At least one game title is required.';
    }
    return Object.keys(this.errors).length === 0;
  }

  async submitForm() {
    this.submitError = '';
    if (!this.validate()) return;
    this.loading = true;
    try {
      const captchaToken = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'broll_request' });
      await axios.post('/api/broll/request', {
        email: this.form.email,
        socials: this.form.socials.filter(s => s.url.trim()),
        games: this.form.games.filter(g => g.trim()),
        captchaToken,
      });
      this.submitted = true;
    } catch (err: any) {
      this.submitError = err?.response?.data?.error || 'Something went wrong. Please try again.';
    } finally {
      this.loading = false;
    }
  }

  resetForm() {
    this.form = { email: '', socials: [{ platform: '', url: '' }], games: [''] };
    this.errors = {};
    this.submitError = '';
    this.submitted = false;
  }
}
